// source: (in gCO2/km) from http://www.sciencedirect.com/science/article/pii/S1352231018307295 and https://www.gov.uk/government/publications/greenhouse-gas-reporting-conversion-factors-2019
export const averagePassengerCarEmissionsEU = 175.0;

// source: (in gCO2/mile) from https://www.epa.gov/greenvehicles/greenhouse-gas-emissions-typical-passenger-vehicle
export const averagePassengerCarEmissionsUS = 400.0;

// source: (in metric tons) https://www.epa.gov/energy/greenhouse-gases-equivalencies-calculator-calculations-and-references#oil
export const barrelOfOilCarbonEmissions = 0.43;

// source: (in grams) https://www.epa.gov/energy/greenhouse-gases-equivalencies-calculator-calculations-and-references#gasoline
export const gasolineCarbonEmissionsPerGallon = 8887;

// source  (in kWh) https://www.epa.gov/energy/greenhouse-gases-equivalencies-calculator-calculations-and-references#lights
export const lightbulbEnergyUsage = 43 / 1000;

// source: (in W/GB) http://dl.acm.org/citation.cfm?doid=3076113.3076117 and https://www.tomshardware.com/uk/reviews/intel-core-i7-5960x-haswell-e-cpu,3918-13.html
export const memoryPowerUsage = 0.3725;

// source: (in metric tons) https://www.epa.gov/energy/greenhouse-gases-equivalencies-calculator-calculations-and-references#smartphones
export const smartphonesChargedCarbonEmissions = 8.22e-6;

// source: http://www.sciencedirect.com/science/article/pii/S0269749101002640
export const treeYear = 11000;

// source: http://www.sciencedirect.com/science/article/pii/S0269749101002640
export const treeMonth = 917;

// source: https://www.iea.org/reports/global-energy-co2-status-report-2019/emissions
export const worldwideCarbonIntensity = 475.0;

// source: https://journal.uptimeinstitute.com/is-pue-actually-going-up/
export const worldwidePowerUsageEffectiveness = 1.67;
